import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Køb 1, få 1',
  [OFFER_TYPE.FREE_ITEM]: 'Gratis vare',
  [OFFER_TYPE.AMOUNT_OFF]: 'Beløbsrabat',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Procentrabat',
};
